import { Hold, Promotion } from 'webshop-api';
import { TicketTypeStateMapper } from '../ticket-type/TicketTypeState.mapper';
import { HoldMaximumAmountProvider, HoldState } from "@/domain/ticket-selection";

export class HoldStateMapper {

    /**
     * whatItDoes
     * maps Hold entity to HoldState
     */
    public static fromHold(object: Hold, applicationTicketMaximum: number, promotion?: Promotion): HoldState {
        return {
            active: object.number === 0,
            number: object.number!,
            maxTickets: HoldMaximumAmountProvider.getMaximumFor(object, applicationTicketMaximum, promotion),
            ticketTypes: object.ticketTypes
                ? object.ticketTypes.map(entity => TicketTypeStateMapper.fromTicketType(entity, applicationTicketMaximum))
                : [],
        };
    }

}
